<template>
  <div class="sidebar-header">
    <div class="sidebar-header-title">
      <img src="../../assets/mycolour.png" alt="Image" />
      <button
        @click="close_sidebar"
        :style="{ transition: 'width 150ms ease', width: `${width}px` }"
      >
        <svg
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 86.001 86.001"
          style="enable-background:new 0 0 86.001 86.001;"
          xml:space="preserve"
        >
          <g>
            <path
              style="fill:#fff;"
              d="M64.998,80.095c1.338,1.352,1.338,3.541,0,4.893c-1.336,1.35-3.506,1.352-4.844,0l-39.151-39.54
            c-1.338-1.352-1.338-3.543,0-4.895l39.15-39.539c1.338-1.352,3.506-1.352,4.844,0C66.335,2.366,66.335,4.556,65,5.907
            L29.294,43.001L64.998,80.095z"
            />
          </g>
        </svg>
      </button>
      <p class="configurator-name">{{ type }} configurator</p>
      <p class="sidebar-total-price">Subtotal: &pound; {{ price }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { EventBus } from '../../eventBus';

export default {
  name: 'SidebarHeaderTitle',
  data() {
    return {
      width: 64,
    };
  },
  computed: {
    ...mapGetters(['type', 'price', 'configurator']),
  },
  mounted() {
    if (document.querySelector('.nav-list.side') === null) return;

    if (this.configurator.configs.length > 3) {
      let widthInterval = setInterval(() => {
        if (document.querySelector('.nav-list.side') !== null) {
          this.width = document.querySelector('.nav-list.side').clientWidth;
          clearInterval(widthInterval);
        }
      }, 250);
    }
  },
  methods: {
    close_sidebar() {
      EventBus.$emit('close-sidebar');
    },
  },
};
</script>
